/* Lane colours of the Jam highway. Green and red mean right and wrong everywhere else in the app (the
   result pops, the review, every exercise), so no lane uses them: a correctly played chord on a red lane
   looked like a mistake. colors.test.ts keeps the hues away from both. */
export const LANE_COLORS = ['#4da3ff', '#ffd23f', '#b388ff', '#2ee6d6', '#ff6ad5', '#ff9f43', '#8c9eff', '#e6c07b'];

/** Hue of a #rrggbb colour in degrees (0..360). */
export function hue(hex: string): number {
  const [r, g, b] = [1, 3, 5].map((i) => Number.parseInt(hex.slice(i, i + 2), 16) / 255) as [number, number, number];
  const max = Math.max(r, g, b);
  const d = max - Math.min(r, g, b);
  if (!d) return 0;
  const h = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return (h * 60 + 360) % 360;
}
